import axios from 'axios';

let providers = [];

export const fetchAvailableGames = async ({ selectedProviders, selectedGameType }) => {
    const params = {
        action: 'available_games',
        token: process.env.NEXT_PUBLIC_TOKEN,
        casino: process.env.NEXT_PUBLIC_CASINO,
        page: 1,
        limit: 3000,
        primaryProviderId: selectedProviders?.length ? selectedProviders.join(',') : '',
        gameType: selectedGameType?.length > 0 ? selectedGameType.join(',') : 'all',
    };

    const url = `${process.env.NEXT_PUBLIC_API_DOMAIN}/games/admin/getAllCombineAPI`;
    const response = await axios.get(url, { params });
    if (!selectedProviders?.length) {
        providers = response?.data?.providers;
    }
    const responses = {
        games: response?.data?.availableGames?.games || [],
        providers,
    };

    return responses;
};
